import { trimEnd } from "lodash";
import { useEffect, useMemo, useState } from "react";

import { mapPhRooms } from "@/lib/common-utils";
import {
  FetchRoomsResponseDto,
  SysCfgCrossRoomRsDto,
  SysCfgRawDto,
  UserResponseRegularDto,
} from "@/shared/api";

export const usePlayhubRooms = ({
  gameGroupsResponse,
  playhubRoomsResponse,
  user,
}: {
  gameGroupsResponse?: SysCfgCrossRoomRsDto;
  playhubRoomsResponse?: FetchRoomsResponseDto;
  user: UserResponseRegularDto;
}) => {
  const gameGroupsData = useMemo(() => {
    if (!gameGroupsResponse?.configs) return {};

    return Object.entries(gameGroupsResponse.configs).reduce(
      (acc: Record<string, SysCfgRawDto[]>, [key, value]) => ({
        ...acc,
        [trimEnd(key, "_eco")]: value,
      }),
      {}
    );
  }, [gameGroupsResponse]);

  const playhubRoomsData = useMemo(
    () => playhubRoomsResponse?.rooms ?? [],
    [playhubRoomsResponse]
  );

  const [playhubRooms, setPlayhubRooms] = useState(
    mapPhRooms(playhubRoomsData, gameGroupsData, user)
  );

  useEffect(() => {
    setPlayhubRooms(mapPhRooms(playhubRoomsData ?? [], gameGroupsData, user));
  }, [gameGroupsData, playhubRoomsData, user]);

  return {
    gameGroupsData,
    playhubRooms,
    setPlayhubRooms,
  };
};
